<template>
  <v-progress-linear class="progress-bar" height="6"
    :indeterminate="true"
    :active="active"
  ></v-progress-linear>
</template>

<script>
export default {
  name: 'nx-layout-default-progress-bar',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
.progress-bar {
  margin-top: 0 px;
  margin-bottom: 0 px;
  position: absolute;
}
</style>
